
// Define your 4 pages in order
export const DEFAULT_PAGES = [
    { id: '', title: 'Cruise Booking' },
    { id: 'trip-information', title: 'Trip Information' },
    { id: 'traveler-information', title: 'Traveler Information' },
    { id: 'payment', title: 'Payment' }
  ];

export const LUGGAGE_TYPES = [
  { 
    id: 'carry-on', 
    name: 'Carry On', 
    weight: '25 lbs / 11kg', 
    dimensions: '48 in / 14 cm', 
    price: 164 
  },
  { 
    id: 'checked', 
    name: 'Checked', 
    weight: '50 lbs / 23 kg', 
    dimensions: '62 in / 157 cm', 
    price: 244 
  },
  { 
    id: 'oversized', 
    name: 'Oversized', 
    weight: '70 lbs / 34 kg', 
    dimensions: '74 in / 188 cm', 
    price: 0 
  }
];

export const SHIPPING_METHODS = [
  { 
    id: 'ground', 
    name: 'Ground', 
    deliveryDays: '5-7', 
    price: 95.22, 
    description: 'Standard ground shipping' 
  },
  { 
    id: 'three-day', 
    name: 'Three Day Express', 
    deliveryDays: '3', 
    price: 122.72, 
    description: 'Faster delivery' 
  },
  { 
    id: 'next-day', 
    name: 'Next Day Express', 
    deliveryDays: '1', 
    price: 270.21, 
    description: 'Overnight delivery' 
  }
];

export const TRIP_TYPES = [
  { id: 'to-cruise', label: 'To cruise' },
  { id: 'from-cruise', label: 'From cruise' },
  { id: 'round-trip', label: 'Round Trip' },
  { id: 'multi-city', label: 'Multi-City' }
];

export const DEFAULT_FORM_DATA = {
  formSignature: '',
  brandId: window.gon?.current_brand || '',
  authToken: window.gon?.auth_token || '',
  tokenizationKey: window.gon?.tokenization_key || '',
  page: {
    index: null,
    current: null,
    previous: null
  },
  tabs: [
    {
      id: 'leg-0',
      title: 'Leg 1',
      subtitle: '',
      price: '100.00',
      closable: true
    }
  ],
  cart: {
    id: null,
    token: null,
    items: []
  },
  clubBillingClubs: [],
  locationType: 'direct',
  legs: [{
    id: 'leg-0',
    legIndex: 0,
    tripType: { id: 'to-cruise', label: 'To cruise' },
    fromAddress: {},
    toAddress: {},
    cruiseSelection: {
      pickup: false,
      delivery: false
    },
    currentCruiseLine: null,
    availablePorts: [],
    currentPort: null,
    currentShip: null,
    currentItinerary: null,
    itineraryFilterField: 'ship_name',
    itineraryFilterLabel: 'Ship Name',
    selectedProducts: [],
    selectedShipping: null,
    pickupDate: '',
    deliveryDate: '',
  }],
  customerInfo: {
    id: '',
    authToken: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: ''
  },
  onBehalfUser: null,
  billingAddress: {
    street: '',
    city: '',
    state: '',
    zip: '',
    country: 'United States'
  },
  paymentMethodType: 'card',
  paymentMethod: {
    paymentMethodId: '',
    cardholderName: '',
    payerEmail: '',
    lastFour: '',
    expiryDate: '',
    billingCountry: '',
    billingZipCode: ''
  },
  cardDetails: {
    last4: '',
    expiry: '',
    name: ''
  },
  subtotal: 0,
  shippingCost: 0,
  tax: 0,
  total: 0
};